<template>
  <v-card flat outlined min-height="75vh" width="100%" height="100%">
    <template v-if="selectedFile && canPreview">
      <iframe width="100%" height="100%" :src="fileUrl"></iframe>
    </template>
    <template v-if="selectedFile && !canPreview">
      <v-card-title class="d-flex align-center justify-center">
        <v-subheader class="text-h5">Preview not available</v-subheader>
      </v-card-title>
      <v-card-text class="d-flex align-center justify-center">
        <v-btn
          @click="downloadFile"
          class="text-decoration-underline"
          color="primary"
          text
          >Click Here to Download</v-btn
        >
      </v-card-text>
    </template>
    <template v-if="!selectedFile">
      <v-card-title class="d-flex align-center justify-center">{{
        noFiles ? "No files to view" : "Select an item to view"
      }}</v-card-title>
    </template>
  </v-card>
</template>
<script>
import { downloadFileUrl } from "../../utils/download-utils";
export default {
  props: ["noFiles"],
  data() {
    return {
      selectedFile: null,
      fileUrl: "",
    };
  },
  computed: {
    canPreview() {
      var extensions = [
        "application/pdf",
        "text/plain",
        "text/html",
        "image/jpeg",
        "image/png",
      ];
      return extensions.includes(this.selectedFile.fileExtension);
    },
  },
  methods: {
    async loadFile(item) {
      this.selectedFile = item;
      this.fileUrl = await this.$store.dispatch("filesModule/getFileUrl", {
        fileId: this.selectedFile.fileId,
      });
    },
    downloadFile() {
      downloadFileUrl(this.fileUrl, this.selectedFile.fileName);
    },
  },
};
</script>
